<template>
    <div class="print-config-notice" v-if="answers.answer.text || (answers.answer.images && answers.answer.images.length)">
        <h3>{{$t('pages.print.custom-notice')}}</h3>
        <p>{{answers.answer.text}}</p>
        <v-layout class="print-config-notice__images">
            <v-flex class="print-config-notice__image-wrap" v-for="thumb in thumbnails">
                <img :src="thumb.src" class="print-config-notice__thumbnail"/>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import {getImageFromResponse} from "@utils/images"
    import {mapActions} from 'vuex'

    export default {
        name: "print-config-notice",
        props: {
            config: {
                type: Object
            },
            answers: {
                type: Object
            },
            level: {
                type: Number
            }
        },
        data: () => ({
            thumbnails: []
        }),
        async created() {
            if (!this.answers.answer.images) return
            await Promise.all(this.answers.answer.images.map(img => {
                    return this.getImageUrl(img.id)
                })
            )
        },
        methods: {
            ...mapActions({
                requestImage: 'mediaObjects/getImage'
            }),
            async getImageUrl(id) {
                const res = await this.requestImage({id, thumb: true})
                const thumbRes = await getImageFromResponse(res)
                this.thumbnails.push({src: thumbRes, id: id})
            }
        }
    }
</script>

<style lang="scss">
    .print-config-notice {
        margin-left: 5%;
        &__images {
            margin: .5rem -.25rem;
            flex-wrap: wrap;
        }
        &__image-wrap {
            flex: 0 0 auto;
            padding: .25rem;
        }
        &__thumbnail {
            width: auto;
            height: 120px;
        }
    }
</style>